import React, { FC, useEffect } from 'react'
import { useLocation } from 'react-router-dom'

interface HfxFormProps {
    FormId: string | undefined
    type: string
    className?: string
    onFormSubmit?: () => void
    onFormReady?: (form: HTMLFormElement) => void
}

const HubspotForms: FC<HfxFormProps> = ({
    FormId,
    type,
    className,
    onFormSubmit,
    onFormReady,
}) => {
    const location = useLocation()
    useEffect(() => {
        const script = document.createElement('script')
        script.src = 'https://js.hsforms.net/forms/v2.js'
        document.body.appendChild(script)

        script.addEventListener('load', () => {
            if (window.hbspt) {
                window?.hbspt?.forms?.create({
                    portalId: process.env.REACT_APP_HUB_SPOT_PORTALID
                        ? process.env.REACT_APP_HUB_SPOT_PORTALID
                        : '',
                    formId: FormId ? FormId : '',
                    target: `#hubspot${type}form`,
                    onFormSubmit: onFormSubmit,
                    onFormReady: onFormReady,
                })
            }
        })
    }, [FormId, type, location.pathname])

    return <div id={`hubspot${type}form`} className={className}></div>
}

export default HubspotForms
